import { Box } from "@mui/material";
import styled from "styled-components";

export const CertificateWrapper = styled(Box)`
  height: calc(100vh - 130px);
  overflow-y: auto;
  overflow-x: hidden;
`;

export const CertificateContainer = styled(Box)`
  padding: 30px 44px 40px 30px;
`;

export const LogoSection = styled(Box)`
  margin-bottom: 58px;

  img {
    display: block;
    height: 40px;
    margin-bottom: 8px;
  }
`;

export const InfoSection = styled(Box)`
  margin-bottom: 20px;
`;
